import { MAP_MAX_ZOOM, MAP_MIN_ZOOM } from '@/constants';
export const tileJsonMapper = (tileJson) => {
    return {
        ...tileJson,
        place: { type: tileJson.type },
        maxzoom: MAP_MAX_ZOOM,
        minzoom: MAP_MIN_ZOOM,
        tiles: [`${process.env.TILE_API_URL}layer/${tileJson.type}/{z}/{x}/{y}.pbf`],
    };
};
